import React from 'react';

import { useAccountContext } from '../Data/accountContext';
import FormBase from '../FormBase';
import Text from '../../../../components/Typography/Text';
import Link from '../../../../components/Typography/Link';
import Checkbox from '../../../../components/Misc/Checkbox';
import CustomerAccountAgreementModal from '../../../../components/Modals/CustomerAccountAgreementModal';
import { attachFiles } from '../../../../services/CommonService';
import { saveRegistrationDisclosure } from '../../../../services/RegistrationService';
import { validateCustomerAccountAgreement, hasError } from '../Data/validation';

export default function FormCustomerAccountAgreement() {
  const { account, setAccount, disableUpdate } = useAccountContext();
  const [validation, setValidation] = React.useState({});

  const [open, setOpen] = React.useState({
    customerAgreementModal: false,
  });

  const handleCloseModal = async (acceptedValue, attachment) => {
    setOpen({
      customerAgreementModal: false,
    });
    if (acceptedValue === 'agreement accepted') {
      await attachFiles(account.accountId, 'ClientAccount', attachment);
      await saveRegistrationDisclosure('Customer Agreement', true);
      setAccount({ ...account, customerAccountAgreement: true });
    }
  };

  React.useEffect(() => {
    if (account.customerAccountAgreement === false) {
      setOpen({
        ...open,
        customerAgreementModal: true,
      });
    }
  }, []);

  const handleSave = async () => {
    const errs = validateCustomerAccountAgreement(account);
    setValidation(errs);
    if (hasError(errs)) {
      console.log('customer account agreement errs', errs);
      return { acct: account, err: true };
    }

    return { acct: account, err: false };
  };

  return (
    <FormBase
      name="customer-account-agreement"
      header="Customer Account Agreement"
      subHeader=""
      faq="Customer Account Agreement"
      save={handleSave}
    >
      <>
        <div className="grd-row">
          <div className="col">
            {!!validation?.customerAccountAgreement && (
              <Text
                ml={10}
                error={!!validation?.customerAccountAgreement}
                label="Please check Customer Account Agreement"
                variant="subtitle1"
              />
            )}
            <Checkbox
              ml={0}
              required={true}
              disabled={disableUpdate}
              labelLink={true}
              name="customerAccountAgreement"
              label={
                <React.Fragment>
                  I have read and accepted the
                  <span
                    onClick={(e) => {
                      setOpen({
                        ...open,
                        customerAgreementModal: true,
                      });
                      e.preventDefault();
                    }}
                  >
                    <Link ml={5} label="Customer Account Agreement" />.
                  </span>
                </React.Fragment>
              }
              checked={account.customerAccountAgreement}
            />
          </div>
          {open.customerAgreementModal && (
            <CustomerAccountAgreementModal
              open={open.customerAgreementModal}
              onClose={handleCloseModal}
              accountData={account}
              disabled={disableUpdate}
            />
          )}
        </div>
      </>
    </FormBase>
  );
}
